import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import axios from 'axios';
import storageSession from 'redux-persist/lib/storage/session';
import {persistReducer} from 'redux-persist';
import {RootState} from './rootReducer'
import {IErrorsAuth,AuthState} from "../models/auth";
import {closeBackdrop, openBackdrop} from "./backdrop";
import {openNotifier} from "./notifier";
const api = process.env.REACT_APP_API_URL

const initialState: AuthState = {
    access_token: null,
    email: '',
    nombre: '',
    enterprises: [],
    permissions:[],
    errors: null,
    loading: false,
    open_dialog:false
}

export const auth = createAsyncThunk<AuthState,
    { username: string, password: string },
    {
        rejectValue: unknown
    }>(
    'app/auth',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {

            const response = await axios.post(`${api}/auth/login`, data);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:`Welcome ${response.data?.data?.nombre}`}))
            thunkApi.dispatch(closeBackdrop());
            return response.data?.data;
        } catch (err) {

            // @ts-ignore

            thunkApi.dispatch(closeBackdrop());
            // @ts-ignore
            thunkApi.dispatch(openNotifier({open:true,variant:"error",message:'El usuario y/o contraseña es incorrecto'}))
            return thunkApi.rejectWithValue('error')
        }
    }
)
export const authSlice = createSlice({
    initialState,
    name: 'auth',
    extraReducers: builder => {
        builder
            .addCase(auth.pending, state => {
                state.loading = true
            })
            .addCase(auth.fulfilled, (state, {payload}) => {
                const {access_token, nombre,enterprises,email,permissions} = payload
                state.access_token = access_token
                state.nombre = nombre
                state.email=email
                state.enterprises=enterprises
                state.permissions=permissions
                state.loading = false
            })
            .addCase(auth.rejected, (state, action) => {
                state.loading = false
            })
    },
    reducers: {
        fillError: (state, action: PayloadAction<IErrorsAuth>) => {
            state.errors = {...action.payload};
        },
        openDialog:(state,action: PayloadAction<boolean>)=>{
            state.open_dialog= action.payload;
        },
        logout:(state)=>{
            state.access_token=null
            state.nombre=''
            state.email=''
            state.enterprises=[]
            state.permissions=[]
            state.errors= null
            state.loading=false
        }
    },
})

export const authSelector = (state: RootState) => state.auth;

export const {
    fillError,
    logout,
    openDialog
} = authSlice.actions;
export const AuthReducer = persistReducer({
    storage:storageSession,
    key: 'auth',
    whitelist: ['access_token', 'user'],
    blacklist:['open_dialog']
}, authSlice.reducer)
